import config from 'config';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';

import { resetClass } from 'srcReact/helpers/utils';
import { subscriptionActions } from 'srcReact/SubscriptionPage';
import Spinner from 'srcReact/components/common2/Spinner';

class CallbackPaymentMethodPageContainer extends Component {
    constructor(props) {
        super(props);

        let query = queryString.parse(location.search)
        if (query && query.state === "succeeded" && query.organization_id && query.new_plan) {
            this.props.updatePlanSimple(query.organization_id, query.new_plan)
        } else {
            window.location = `${config.webUrl}`
        }

        resetClass(document.body, 'callback-payment-method-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('callback-payment-method-page');
    }

    componentDidUpdate() {
        const { subscriptionPlan } = this.props;
        if (subscriptionPlan && subscriptionPlan.updated) {
            window.location = `${config.webUrl}/0/pricing?success_popin=true`
        }

        if (subscriptionPlan && subscriptionPlan.error) {
            window.location = `${config.webUrl}/0/pricing`
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="loader-container d-flex justify-content-center align-items-start pt-3">
                    <p className="alert alert-success text-center"><Spinner/></p>
                </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    const { alert, organization, subscription } = state;
    const { current_organization } = organization;
    const { loggingIn, user } = state.login;
    const { subscriptionPlan } = subscription;
    return { alert, loggingIn, user, current_organization, subscriptionPlan }
}

const actionCreators = {
    updatePlanSimple: subscriptionActions.updatePlanSimple,
};

const ExtendedComponent = withTranslation('common')(CallbackPaymentMethodPageContainer);

const connectedCallbackPaymentMethodPageContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent);
export { connectedCallbackPaymentMethodPageContainer as CallbackPaymentMethodPageContainer };
